import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DocumentSidebarComponent } from '../../documents/document-sidebar/document-sidebar.component';

import { Doc } from '../../../models/doc';

import { DocumentService } from '../../../services/documents/document.service';
import { DocumentStoreService } from '../../../services/documents/document-store.service';

declare var jQuery: any;

@Component({
  selector: 'app-outgoing-form-dialog-attachments',
  templateUrl: './outgoing-form-dialog-attachments.component.html',
  styleUrls: ['./outgoing-form-dialog-attachments.component.css'],
})
export class OutgoingFormDialogAttachmentsComponent implements OnInit {
  @Input() mainDocumentId: number;

  @Input() matter_id: number;

  @Input() attachments: Array<any> = [];

  @Output() attachmentsSelected: EventEmitter<any> = new EventEmitter();

  doc: Doc | null;

  loading: boolean = true;

  search_options: any = {
    document_types: [],
    document_authors: [],
    tags: [],
  };

  search_params: any = {
    page: 1,
    per_page: 30,
  };

  count: number = 0;

  documents: Array<any> = [];

  constructor(private documentService: DocumentService, private documentStoreService: DocumentStoreService) {}

  // Component lifecycle events
  ngOnInit() {
    if (this.matter_id)
      this.documentService.getMatterSearchOptions(this.matter_id).then((response_json) => {
        this.search_options = response_json;
        this.search_params.per_page = response_json.per_page;
        this.search_params.matter_id = this.matter_id;
        this.loadDocuments();
      });
    let documentSidebarComponent: DocumentSidebarComponent | null = this.documentStoreService.documentSidebarComponent;
    if (documentSidebarComponent) this.doc = documentSidebarComponent.doc;
  }

  // Component methods
  formatNameShort(name: string): string {
    return name.slice(0, 14) + '...' + name.split('.')[1];
  }

  loadDocuments(pageNumber: any = null, sortType: string | null = null) {
    if (pageNumber) this.search_params.page = pageNumber.page;
    if (sortType) this.search_params.sort_type = sortType;
    this.documentService.getDocuments(this.search_params).then((response_json) => {
      let documents = response_json.documents;
      this.documents = [];
      for (let index in documents) {
        let document = documents[index];
        if (this.doc && document.id == this.doc.id) continue;
        for (let attachment of this.attachments) if (attachment.id == document.id) document.selected = true;
        document.shortName = this.formatNameShort(document.name);
        this.documents.push(document);
      }
      this.count = response_json.count;
      this.loading = false;
    });
  }

  miniPreview(attachment: any) {
    jQuery(`.document_attachment_mini_iframe_${attachment.id}`).attr('src', `/documents/${attachment.id}/download?disposition=inline`);
  }

  toggleAttachment(document: any) {
    if (document.selected) {
      let attachmentIndex: number | undefined = undefined;
      let attachmentPresent: boolean = false;
      for (let index in this.attachments) {
        let attachment: any = this.attachments[Number(index)];
        if (attachment.id == document.id) {
          attachment.selected = false;
          attachmentIndex = Number(index);
          attachmentPresent = true;
          break;
        }
      }
      if (attachmentPresent && attachmentIndex) {
        this.attachments.splice(attachmentIndex, 1);
        this.attachmentsSelected.emit(this.attachments);
      }
    } else {
      for (let attachment of this.attachments) {
        if (attachment.id == document.id) return;
      }
      document.selected = true;
      if (!document.copies) document.copies = 1;
      if (!document.pages) document.pages = 'all';
      this.attachments.push(document);
      this.attachmentsSelected.emit(this.attachments);
    }
  }
}
